// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".credit-warning[data-v-da5f8a92]{display:flex;align-items:center;justify-content:flex-start;align-self:flex-end;padding:15px 10px 0}.credit-warning img[data-v-da5f8a92]{width:50px;height:50px;margin-right:20px}.credit-warning .inner[data-v-da5f8a92]{padding-top:0;flex:1}.credit-warning .inner span[data-v-da5f8a92]:first-child{display:block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
